import React, { Component } from "react";
import { connect } from "react-redux";
import "react-bootstrap-table/dist/react-bootstrap-table.min.css";
import { Alert } from "react-bootstrap";
import { DckSelectors } from "dck-redux";
import ProcessTypes from "../../redux/processes/types";
import { importBatches } from "../../redux/actions/import";

import "./styles.css";
import CustomPageHeader from "../fragments/CustomPageHeader";

class Import extends Component {

  handleChange(e) {
    if(e.target.files && e.target.files.length > 0) {
      this.props.importBatches(e.target.files[0]);
      e.target.value = null;
      e.target.files = null;
    }
  }

  render() {
    return (
      <div>
        <CustomPageHeader icon='upload' text='Batches' />

        <div id="main-import-div">
          <div id="import-button-div">

            <input
              type="file"
              id="file_input"
              className="inputfile hidden-input-file"
              onChange={e => this.handleChange(e)}
            />
            <label htmlFor="file_input">Import Batches</label>

            { this.props.uploadProcessed && this.props.uploadProcessed.result ? (
              this.props.uploadProcessed.success ? (
                <Alert bsStyle="warning" className="alert-message">
                  <strong>Successfully uploaded!</strong>
                </Alert>
              ) : (
                <Alert bsStyle="danger" className="alert-message">
                  <strong>Upload Failed!</strong>
                </Alert>
              )
            ) : null
            }
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const mapping = {
    uploadProcessed: DckSelectors.selectProcess(state, ProcessTypes.BATCHES_IMPORT)
  };
  return mapping;
};

const mapDispatchToProps = dispatch => {
  return {
    importBatches: file => dispatch(importBatches(file))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Import);



// WEBPACK FOOTER //
// ./src/components/Import/index.js